import { useMutation } from "@tanstack/react-query";
import { AuthRepositoryImpl } from "../../../data/repository/auth_repository_impl";
import { AxiosError } from "axios";

export const useCheckEmailAvailable = () => {
    const repository = new AuthRepositoryImpl();

    return useMutation<'available' | 'taken' | 'wrongEmailDomain' | 'other', AxiosError, { email: string, code: string }>({
        mutationFn: ({ email, code }) => repository.checkEmailAvailable(email, code),
    });
};